// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-10-12T21:55:43Z                      #

// ##############################################################


export const RECAPTCHA = 'RECAPTCHA';

export const FRIENDLYCAPTCHA = 'FRIENDLYCAPTCHA';

export const ALTCHA = 'ALTCHA';

/**
 * Seznam všech hodnot.
 */
export const values = [
    RECAPTCHA,
    FRIENDLYCAPTCHA,
    ALTCHA
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [RECAPTCHA]: {caption: ''},
    [FRIENDLYCAPTCHA]: {caption: ''},
    [ALTCHA]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}